import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { CALCULATE_INSURANCE_OFFERS } from '../apollo/mutations';
import { getBirthAge } from '../helpers/getBirthAge';
import { IInsurance } from '../types';

const useCalculateInsurance = () => {
  const [calculateOffers, { data, loading }] = useMutation(
    CALCULATE_INSURANCE_OFFERS,
    { fetchPolicy: 'network-only' }
  );

  const getOffers = useCallback(
    (insurance: IInsurance) => {
      const { details, beneficiary } =
        insurance || {};      

      let startDate = details.start_date;
      let singleTouristAge:any[] = [];
     
      let endDate = details.end_date;     

      const isGroup = beneficiary.length > 1;     

      if (beneficiary.length) singleTouristAge.push({ year_of_birth: getBirthAge(beneficiary[0]?.date_of_birth) });     

      const touristsAges = beneficiary.map((tourist) => {
        if (tourist?.date_of_birth) {
          return { year_of_birth: getBirthAge(tourist?.date_of_birth) };
        }
        return { year_of_birth: '2022' };
      });      
 
      calculateOffers({
        variables: {
          input: {
            insurance_type: 'travel_medical',
            beneficiary: isGroup ? touristsAges : singleTouristAge,
            details: {
              destination: details?.destination,
              beneficiary_in_md: true,
              one_trip: true,
              start_date: startDate,
              end_date: endDate,
              purpose: 'tourism',
              covid_cover: true,
              insurance_form: 'individual',
            },
          },
        },
      });
      
      return data;
    },
    [data, calculateOffers]
  );
  return { getOffers, availableOffers: data, isLoading: loading };
};

export default useCalculateInsurance;

